import Vue from 'vue'
import './plugins/axios'
import './plugins/index'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './iconfont/iconfont.css';
import '@/layout/export'
import moment from 'moment'
import $aes from './common/aes'

Vue.config.productionTip = false
Vue.prototype.$aes = $aes
Vue.prototype.$moment = moment
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk chunk-(\d\D*)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log(targetPath)
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
